import setCurrentPage from "src/Utils/setCurrentPage";
import store from "src/Reducers/store";
import ConversationEffect from "src/Animations/ConversationEffect";

const previousPage = () => store.getState().appReducer.previousPage;

export const DATA_ACCESS_NETWORK_ROLLOUT_INLCM_1_1 = {
  title: "Orchestrating the network life cycle \nstages for fiber rollout",
  subtitle: "Access Network Rollout",
  next: {
    label: "CONTINUE",
    onClick: () => setCurrentPage("ENG_3155"),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage(previousPage()),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "ENG/INLCM/INLCM_dark_bg_2.png",
  rightSideComponent: (
    <ConversationEffect
      images={[
        {
          image: "ENG/INLCM/INLCM_digital_twin_01_computer.png",
          effect: "animate-opacity",
          imageStyle: { position: "absolute", bottom: "160px", right: "0px" },
        },
        {
          image: "ENG/INLCM/INLCM_access_net_01_1_screen.png",
          imageStyle: { position: "absolute", right: "103px" },
        },
      ]}
      pageNumber={"ENG_315"}
    />
  ),
};
